exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/_object-gops.js
// module id = 76
// module chunks = 0